"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 工具方法，检测对象的类型
 * @param o 对象
 * @return 对象的类型(Internal Class)字符串
 */
function type(o) {
    return Object.prototype.toString
        .call(o)
        .slice(8, -1)
        .toLowerCase();
}
var LEADING_UNDERSCORE_REGEXP = /^\_+/g;
var SNAKECASE_PAIR = /\_+[A-Za-z0-9]/g;
/**
 * 下划线转驼峰
 * @param str
 * @return
 */
function snakeToCamel(str) {
    var leadingUnderscore = (String(str || '').match(LEADING_UNDERSCORE_REGEXP) || [])[0] || '';
    return (leadingUnderscore +
        String(str || '')
            .replace(LEADING_UNDERSCORE_REGEXP, '')
            .replace(SNAKECASE_PAIR, function (m) {
            return m[m.length - 1].toUpperCase();
        }));
}
exports.snakeToCamel = snakeToCamel;
var LEADING_CAPITAL_WORD = /^[A-Z]+/;
var CAMELCASE_PAIR = /\.?([A-Z]+)/g;
/**
 * 驼峰转下划线
 * @param str
 * @return
 */
function camelToSnake(str) {
    return String(str || '')
        .replace(LEADING_CAPITAL_WORD, function (m) {
        return m.toLowerCase();
    })
        .replace(CAMELCASE_PAIR, function (_, c) {
        return '_' + c.toLowerCase();
    });
}
exports.camelToSnake = camelToSnake;
function convertorGenerator(convertor) {
    return function f(obj) {
        if (type(obj) === 'object') {
            return Object.keys(obj).reduce(function (output, key) {
                output[convertor(key)] = f(obj[key]);
                return output;
            }, {});
        }
        if (type(obj) === 'array') {
            return obj.map(f);
        }
        return obj;
    };
}
exports.camelKeys = convertorGenerator(snakeToCamel);
exports.snakeKeys = convertorGenerator(camelToSnake);
